import React from 'react'
import Theme from 'styles/theme'
import styled from 'styled-components'
import { media } from 'styles/media'
import { useTranslation } from 'react-i18next'

import ButtonLink from 'components/display/ButtonLink'
import { ParagraphXs } from 'components/display/Typography'
import CameraProDetailed from 'components/icons/CameraProDetailed'
import CamperTrailerDetailed from 'components/icons/CamperTrailerDetailed'
import { SectionHeader, SectionRow, BaseCard } from '../styles'

interface CardProps {
  backgroundColor?: string
}

const ColouredCard = styled(BaseCard)<CardProps>`
  border-color: ${({ backgroundColor }) => backgroundColor || 'transparent'};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'transparent'};
  ${media.md<CardProps>`
    width: 50%;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
  `}
  h4 {
    margin-bottom: 16px;
  }
  p {
    margin-bottom: 16px;
  }
`

const ColouredCardIcon = styled.div`
  margin-left: 35px;
  svg {
    width: 48px;
    height: 48px;
  }
  ${media.lg`
    svg {
      width: 64px;
      height: 64px;
    }
  `}
`

const CommunitySection = () => {
  const [t] = useTranslation('spelling')
  return (
    <>
      <SectionHeader>Get community support</SectionHeader>
      <SectionRow>
        <ColouredCard backgroundColor={Theme?.['-ds-core-50']?.value}>
          <div>
            <h4>For Hosts</h4>
            <ParagraphXs>
              Get help managing your listing, getting paid, communicating with{' '}
              {t('traveler')}s, and more.
            </ParagraphXs>
            <ButtonLink
              href="https://help.riparide.com/en/collections/78185-hosting-with-riparide"
              target="_blank"
              uppercase={false}
              ghost
              inline
              compact
            >
              Host support
            </ButtonLink>
          </div>
          <ColouredCardIcon>
            <CamperTrailerDetailed />
          </ColouredCardIcon>
        </ColouredCard>
        <ColouredCard backgroundColor={Theme?.['-ds-information-100']?.value}>
          <div>
            <h4>For Storytellers</h4>
            <ParagraphXs>
              For questions you have about Story Assignments, submitting
              Stories, and more.
            </ParagraphXs>
            <ButtonLink
              href="https://help.riparide.com/en/collections/1866296-storytelling"
              target="_blank"
              uppercase={false}
              ghost
              inline
              compact
            >
              Storyteller support
            </ButtonLink>
          </div>
          <ColouredCardIcon>
            <CameraProDetailed />
          </ColouredCardIcon>
        </ColouredCard>
      </SectionRow>
    </>
  )
}

export default CommunitySection
